import React, { Component } from "react"
import { searchTableFilter, SumTable } from "../Tree/Utils.js"
import SearchBar from '../Tree/components/SearchBar.jsx'
import { /*GetFamiliesEP,*/ GetCombosEP } from '../../variables/Config' 
import { ProjectName } from '../../variables/DigmaDef' 
import { needSolutionEntity, years2015_2026 } from '../../variables/ComboValues'
import YSpinner from  '../../elements/Spinner/Spinner'
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'


//import { EditableCell } from '../TableList/EditableCell'
// import { ProductRow } from './TermsTable'
// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

// export for translate only
export const  NS_microLegend = { 
  table_title: "צרכים ומענים",
  // needsolution_name: "שם מלא",
  needsolution_role: "המוטב",
  needsolution_area: "תחום",
  needsolution_need: "צורך",
  needsolution_solution: "מענה",
  needsolution_supplier: "ספק",
  needsolution_cost: "עלות",
  needsolution_comment: "הערות",
  needsolution_year_budget: 'שנת תקציב',
  needsolution_yahav: ProjectName,
  needsolution_self: "עצמי",
  needsolution_revaha: "רווחה",
  needsolution_youth: "קרן Y",
  needsolution_Zedaka: "קרן X",
  needsolution_government: "ממשלה",
  needsolution_supplier_reduction: "הנחת ספק",
  needsolution_total: "סך הכל"
}

export class NeedSolutionsTable extends Component {
    constructor(props) {
      super(props)
      this._isMounted = false;

      this.state = { 
            terms: [],  // table lines with value
            cpt: {}, // Custom post type containig data + more DB info
            isLoading: true, restError:"", 
            combos: [], areas:[], needs: [], solutions: [], sources: [] // "combo" values or selection fields
        }
      //var combos = this.getCombos("hhhh")  TODO
      //console.log("NeedSolutionsTable constuctor ", this.props.fullTable)
      this.getCombos = this.getCombos.bind(this)
    }
    /*
    addCombo = (newCombo) => {
        this.setState(prevState => ({
            combos: [...prevState.combos, newCombo]
        })); 
      }
    */
    getCombos = () => {
        //const baseUrl = 'http://yahav/wp-json/wp/v2/digma_combos' // main cpt source
        //const suffixUrl = '&fields=id,title,acf' // selcted fields
        //const url = baseUrl + '?slug="'+urli+ '"' + suffixUrl // "needsolution_area"' +

        // const url = baseUrl + '/6196?fields=id,title,acf'  // GetCombosEP
        // const url = GetCombosEP() + '/6196?fields=id,title,acf'  // 
        const url = GetCombosEP + '/6196?fields=id,title,acf'  // 

        fetch(url)
            .then(response => {
                // console.log("getcombos-respone", response)
                if (!this._isMounted) new Error('getCombos: Aborted nicely ...')
                if (response.ok)
                    return response.json()
                throw new Error('getCombos: Something went wrong ...')
            })
            .then(cpt => { 
                //console.log("get combos cpt", cpt['acf']['areas'])
                var combos = cpt['acf']['areas']

                const areas = []
                const needs = []
                const solutions = []
        
                combos.map(x => {
                    areas.push(x['area_name'])   // build area list in areas
                    needs[x['area_name']] = x['area_table'].map(y => {
                        solutions[y['need-title']] = y['solution-table'].map(z => z['sol-value'])
                        return y['need-title']
                    })
                    return null
                })
                var sources = cpt['acf']['finance_sources']
                if (!this._isMounted) return null
                this.setState({combos, areas, needs, solutions, sources, isLoading:false})
                // console.log("get combos fetch:term array", combos[0])
                // let newc = [this.state.combos, combos[0]] - must use prevState
                //this.addCombo(combos)
                
                return combos
            })
            .catch(restError => console.log("getCombos FAILED: ", restError) /* this.setState({ restError: restError, isLoading: false })*/)
        return null
    }

    componentDidMount(){
        this._isMounted = true

        //this.setState({  isLoading:true  })     // modalRoot: document.getElementById('modal-root'),
        // var uri = "http://yahav/wp-json/wp/v2/digma_families/"+this.props.familyPostId+"?fields=id,title,acf" 
        //const uri = GetFamiliesEP + "/" + this.props.familyPostId+"?fields=id,title,acf" 
        
        //var fields = "per_page=100&fields=id,title,acf";
        
        // this.fetchTerm(uri)
        this.setState({  terms : this.props.data, isLoading:true  })
        
        this.getCombos() // post is ugrrrr..
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    handleRowDel(term) {
        if (this.state.terms.length > 1){
            var index = this.state.terms.indexOf(term)
            if (index === -1)
                return console.log("NeedSolutionsTable handleRowDel " + term + " not found")
            var array = [...this.state.terms]
            array.splice(index, 1)
            this.setState({terms:array})
            //this.state.terms.splice(index, 1)
            //this.setState(this.state.terms)  
        }
    }
/* no need???? 
    saveToDB(terms, id){
        this.props.save2DB(this.props.familyPostId, terms, this.props.subTableId, "table", this.props.inUpdate )
    }
*/
    handleAddEvent(evt) {
      evt.preventDefault()
      var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
      var term = {
        id: id,
        // needsolution_name: "שם מלא",
        needsolution_role: "אב",
        needsolution_area: "כלכלי",
        needsolution_need: "הגדלת הכנסה",
        needsolution_solution: "כלים למציאת עבודה",
        needsolution_supplier: "",
        needsolution_cost: "0",
        needsolution_comment: "",
        needsolution_year_budget: "",
        needsolution_yahav: parseInt(0),
        needsolution_self: parseInt(0),
        needsolution_revaha: parseInt(0),
        needsolution_youth: parseInt(0),
        needsolution_Zedaka: parseInt(0),
        needsolution_government: parseInt(0),
        needsolution_supplier_reduction: parseInt(0),
        needsolution_total: parseInt(0)
      }
        //  console.log("ADDline event",this.state.terms)
        let newt = ""
        if (this.state.terms === undefined){
            newt = [term]
        } else {
            newt = Object.assign(this.state.terms)
            newt.unshift(term)
        }
        this.setState({terms:newt})

    }
  
    handleProductTable(evt) {
        evt.preventDefault()
        var item = {
            //id: evt.target.id,
            name: evt.target.name,
            value: evt.target.value,
            nid: evt.target.getAttribute('data-id')
        }
        // console.log("pRODUCT-EVT", item);
        let t = Object.assign(this.state.terms)
        var terms = t.slice();
        //console.log("terms-EVT", terms);
        var foundit = 0
        var newProducts = terms.map(term => {
            for (var key in term) {
                if (key === item.name && term.id === item.nid) {  
                    foundit = 1                                                        
                    term[key] = item.value
                }
            }
           if (!foundit){
                //let keys=[]
                //for (key in term) keys.push(key)
                //console.log("handleProductTable: key "+keys+"in term not found", terms)
            }
            return term
        })
        this.setState({terms:newProducts})
    }
    // update data base
    onProductSaveTable(evt) {
        evt.preventDefault()
        // const { terms, cpt} = this.state
        // this.saveToDB(terms, cpt['id'])
        const cptId = this.props.familyPostId
        const data = this.state.terms
        const { inUpdate, mbouser} = this.props
        const dataType = "table"
        const dataId = this.props.subTableId
// console.log("NeedSolution dataId = ", dataId)
        this.props.save2DB(cptId, data, dataId, dataType, inUpdate, mbouser)
    }

    render() {
        if (this.state.isLoading)
            return <YSpinner />
        if (this.state.restError !== "")
            return <h2>תקלה חולפת: {this.state.restError}</h2>
        //if (typeof this.state.terms === "undefined")
        //    console.log("FINALLY-needsolutions terms- UNDEFINED")
        //else
        //    console.log("FINALLY-DEFINED needsolutions terms", this.state.terms)
        let title = this.props.tableTitle === undefined? "צרכים ומענים" : this.props.tableTitle
        const headerColumnsMgr = [/*"needsolution_name", */ "needsolution_role", "needsolution_area", "needsolution_need",
                            "needsolution_solution", "needsolution_supplier", "needsolution_cost", "needsolution_comment",
                            "needsolution_year_budget", 
                            "needsolution_yahav", "needsolution_self", "needsolution_revaha","needsolution_youth",
                            "needsolution_Zedaka","needsolution_government", "needsolution_supplier_reduction", "needsolution_total"]
        const headerColumns = [/*"needsolution_name", */ "needsolution_role", "needsolution_area", "needsolution_need",
        "needsolution_solution", "needsolution_supplier", "needsolution_cost", "needsolution_comment" ]
        // console.log("SOURCES", this.state.sources)

        return (
            <div>
                <ProductTable 
                    onProductTableUpdate={this.handleProductTable.bind(this)} 
                    headerColumns = {this.props.fullTable ? headerColumnsMgr : headerColumns}
                    tableTitle = {title}
                    onRowAdd={this.handleAddEvent.bind(this)} 
                    onRowDel={this.handleRowDel.bind(this)} 
                    onProductSaveTable = {this.onProductSaveTable.bind(this)}
                    terms={this.state.terms} 
                    combos={this.state.combos} 
                    areas={this.state.areas} 
                    needs={this.state.needs} 
                    solutions={this.state.solutions} 
                    sources={this.state.sources} 
                    fullTable = {this.props.fullTable}
                />
                <div style={{height:'400px'}}></div>
            </div>
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : "",
            areas: [], needs: [], solutions: [], sources: []
        }
    }
   
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }

    // shows select options - 
    // Holds thelogic of which list of values to display
    showOptions = (index, lineValues) => { 
        const { areas, needs, solutions } = this.props
        
        if (index === "needsolution_area"){
            if (index !== "needsolution_area" && (lineValues === undefined || lineValues === "" || lineValues === {}  ))
                return ""
            //console.log("showOptions - areas", areas)
            return areas
        } else if (index === "needsolution_need"){
            if (needs[lineValues["needsolution_area"]] === undefined 
                || lineValues["needsolution_area"] === {} || lineValues["needsolution_area"] === "" ){
                console.log("NEEDS not defined for " + lineValues["needsolution_area"] + " needs table=", needs[0])
                return needs[0] // default
            }
            //console.log("showOptions - need", lineValues["needsolution_area"])
            return needs[lineValues["needsolution_area"]]
        } else if (index === "needsolution_solution"){
            // console.log("showOptions - solution", solutions[lineValues["needsolution_need"]]) 
            if (solutions[lineValues["needsolution_need"]] === undefined 
                || lineValues["needsolution_need"] === {} || lineValues["needsolution_need"] === "" ){
                console.log("Solutions not defined for lineValues['needsolution_need']", lineValues["needsolution_need"])
                return solutions[0] // default
            }
            //console.log("solutions solutions =" + lineValues["needsolution_need"] + "<<solutions array>>", solutions)
            return solutions[lineValues["needsolution_need"]]
        }
    }
    
    fillLine(line){
        // Logic to make sure that all 3 dependencies are kept
        // including setting default values to fields
        const { solutions, needs, areas } = this.props
        if (line.needsolution_area === "") line.needsolution_area= areas[0]
        if (line.needsolution_need === "") line.needsolution_need= needs[line.needsolution_area][0]
        if (!needs[line.needsolution_area].includes(line.needsolution_need)){
            line.needsolution_need = needs[line.needsolution_area][0]
        }
        if (!solutions[line.needsolution_need].includes(line.needsolution_solution)){
            line.needsolution_solution = solutions[line.needsolution_need][0]
        }
        var cellData=[/*{
            type: "text",
            name: "needsolution_name",
            value: line['needsolution_name'],
            id: line.id,
            style: {width: "70px"},
            display: true,
            edit: true
        },*/{
            type: "select",
            options: needSolutionEntity, // ["אב", "אם", "ילד", "בני זוג", "משפחה", "ילדים"],
            name: "needsolution_role",
            value: line.needsolution_role,
            id: line.id,
            style: {width: "70px"},
            display: true,
            edit: true
        },{
            type: "selectf",
            options: "", // works well as array areas,
            name: "needsolution_area",
            value: line.needsolution_area,
            id: line.id,
            style: {width: "80px"},
            display: true,
            edit: true
        },{
            type: "selectf",
            options: "", //() => {return this.needsf("כלכלי" /*line.needsolution_area*/)},
            name: "needsolution_need",
            value: line.needsolution_need,
            id: line.id,
            style: {width: "150px"},
            display: true,
            edit: true
        },{
            type: "selectf",
            options: "",
        //    options: solutions[line.needsolution_need],

            name: "needsolution_solution",
            value: line.needsolution_solution || 'יעוץ וליווי',
            id: line.id,
            style: {width: "230px"},
            display: true,
            edit: true
        },{
            type: "text",
            name: "needsolution_supplier",
            value: line.needsolution_supplier,
            id: line.id,
            style: {width: '120px'},
            display: true,
            edit: true
        },{
            type: "text",
            name: "needsolution_cost",
            value: line.needsolution_cost,
            id: line.id,
            style: {width: "50px"},
            display: true,
            edit: true
        },{
            type: "textarea",
            name: "needsolution_comment",
            value: line.needsolution_comment,
            id: line.id,
            style: {width: "200px", height: "45px"},
            display: true,
            edit: true
        },{ 
            type: "select",
            options: years2015_2026, // ["2015","2016","2017","2018","2019","2020","2021","2022","2023","2024","2025","2026"],
            name: "needsolution_year_budget",
            value: line.needsolution_year_budget,
            id: line.id,
            style: {width: "65px"},
            display: this.props.fullTable,
            edit: true
        },{ 
            type: "text",
            name: "needsolution_yahav",
            value: parseInt(line.needsolution_yahav),
            id: line.id,
            style: {width: "45px"},
            display: this.props.fullTable,
            edit: true
        },{
            type: "text",
            name: "needsolution_self",
            value: parseInt(line.needsolution_self),
            id: line.id,
            style: {width: "45px"},
            display: this.props.fullTable,
            edit: true
        },{
            type: "text",
            name: "needsolution_revaha",
            value: parseInt(line.needsolution_revaha),
            id: line.id,
            style: {width: "45px"},
            display: this.props.fullTable,
            edit: true
        } ,{
            type: "text",
            name: "needsolution_youth",
            value: parseInt(line.needsolution_youth),
            id: line.id,
            style: {width: "45px"},
            display: this.props.fullTable,
            edit: true
        }
        ,{
            type: "text",
            name: "needsolution_Zedaka",
            value: parseInt(line.needsolution_Zedaka),
            id: line.id,
            style: {width: "45px"},
            display: this.props.fullTable,
            edit: true
        },{
            type: "text",
            name: "needsolution_government",
            value: parseInt(line.needsolution_government),
            id: line.id,
            style: {width: "45px"},
            display: this.props.fullTable,
            edit: true
        },{
            type: "text",
            name: "needsolution_supplier_reduction",
            value: parseInt(line.needsolution_supplier_reduction),
            id: line.id,
            style: {width: "45px"},
            display: this.props.fullTable,
            edit: true
        },{
            type: "text",
            name: "needsolution_total",
            value: line.needsolution_total = parseInt(line.needsolution_supplier_reduction)+parseInt(line.needsolution_government) + parseInt(line.needsolution_Zedaka) + parseInt(line.needsolution_youth) 
                + parseInt(line.needsolution_revaha ) + parseInt(  line.needsolution_self ) + parseInt( line.needsolution_yahav),
            
            // line.needsolution_total,//line.government, // +parseInt(line.supplier)+parseInt(line.yahav),
            id: line.id,
            style: parseInt(line.needsolution_total) !== parseInt(line.needsolution_cost) 
                    ? {width: "50px",color: 'red'} : {width: "40px",color: 'green'},
            display: this.props.fullTable,
            edit: false
        }]
   
        return cellData
    }
    termList(terms, linekey){
        const {onProductTableUpdate, onRowDel} = this.props
        var filterText = this.state.filterText;
        var term = terms.map( line => {
            // search over all cells - perform search filter
            if (!searchTableFilter(line, filterText))
                return null;
            
            return (
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    term={line} 
                    // onDelEvent={onRowDel.bind(this)}
                    onDelEvent={onRowDel.bind(this, line)} 
                    fullTable={this.props.fullTable}
                    key={linekey++}
                    cd={this.fillLine(line)}
                    showOptions = {this.showOptions}
                    line = {line}
                    />)
      })
      return term
    }
    render() {
        const { onProductTableUpdate, onProductSaveTable, onRowDel, onRowAdd, headerColumns, terms, tableTitle } = this.props
        //var filterText = this.state.filterText;
        var thStyle = { fontSize: '15px',color:'#333', fontWeight: 'bold'}
        var buttonStyle = {marginRight: '0'}
        var searchbarStyle = {margin: '5px 10px'}
        
        var linekey = 0
        
        if (terms === undefined){
            const { solutions, needs, areas } = this.props
            var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
            var line = {
                id: id,
               // needsolution_name: "שם מלא",
                needsolution_role: needSolutionEntity[0], //"אב",
                needsolution_area: areas[0], //"כלכלי",
                needsolution_need: needs[areas[0]][0], //"הגדלת הכנסה",
                needsolution_solution: solutions[needs[areas[0]][0]][0], // "כלים למציאת עבודה",
                needsolution_supplier: "",
                needsolution_cost: "0",
                needsolution_comment: "",
                needsolution_year_budget: "",
                needsolution_yahav: parseInt(0),
                needsolution_self: parseInt(0),
                needsolution_revaha: parseInt(0),
                needsolution_youth: parseInt(0),
                needsolution_Zedaka: parseInt(0),
                needsolution_government: parseInt(0),
                needsolution_supplier_reduction: parseInt(0),
                needsolution_total: parseInt(0)
              }
              return (
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    term={line} 
                    // onDelEvent={onRowDel.bind(this)}
                    onDelEvent={onRowDel.bind(this, line)} 
                    fullTable={this.props.fullTable}
                    key={linekey++}
                    cd={this.fillLine(line)}
                    showOptions = {this.showOptions}
                    line = {line}
                    />)
        } 

      return (
        <div className="yahav-modal overflowX">
            <h2>{tableTitle}&nbsp;(סה"כ&nbsp;{terms.length})</h2>
            <button style={buttonStyle} type="button" onClick={onRowAdd} className="btn btn-success pull-right">הוספת שורה</button>
            <button style={buttonStyle} type="button" onClick={onProductSaveTable} className="btn btn-success pull-left">עדכון</button>
            <SearchBar style={searchbarStyle} filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)} />
            <SumTable products={terms} field={'needsolution_cost'} title={'סה"כ עלויות'} />
            <SumTable products={terms} field={'needsolution_yahav'} title={'סה"כ '+ProjectName} />
            <SumTable products={terms} field={'needsolution_total'} title={'סה"כ מתוקצב'} />
            <table className="table ">
                <thead>
                    <tr >
                    {headerColumns.map (col => { 
                      return(<th style={thStyle} key={col}>{NS_microLegend[col]?NS_microLegend[col] : col}</th>) 
                  }) } 
                    </tr>
                </thead>  
                <tbody>
                    {this.termList(terms, linekey) /*term*/}
                </tbody>
            </table>
        </div>
      )
    }
  }

  ///////////////////// generic zone
  class ProductRow extends React.PureComponent {
    onDelEvent() {
      this.props.onDelEvent(this.props.product)
    }
    render() {
        const {onProductTableUpdate, cd, showOptions, line} = this.props
        var key = 0
        return (
            <tr className="eachRow">
                {cd.map(cellInfo => {
                    if (cellInfo.display === false) return null;
                    return (<EditableCell key={key++} 
                                onProductTableUpdate={onProductTableUpdate} 
                                cellData={cellInfo} 
                                showOptions={showOptions} 
                                lineValues={line} 
                                /> )
                })}
            
                <td className="del-cell">
                    <input type="button" onClick={this.onDelEvent.bind(this)} value="X" className="del-btn"/>
                </td>
            </tr>
        )
    }
  }
  class EditableCell extends React.PureComponent {
    render() {
        const tp  = this.props
        const tpc = this.props.cellData
        const { showOptions, lineValues } = this.props
        const tdStyle = {padding: 0, borderTop: 0, paddingLeft: '2px'}
        if (tpc.type === "selectf") // Functional select provides special logic
            return (
                <td style={tdStyle}>
                    <SelectF tp={tp} tpc={tpc} opdisable={true} foptions={showOptions( tpc.name, lineValues)} />
                    {/*<select style={tpc.style} name={tpc.name} id={tpc.id} value={tpc.value} onChange={tp.onProductTableUpdate} > 
                        <option  key={111111} value="נא לבחור" disabled > נא לבחור </option>
                        {
                              showOptions( tpc.name, lineValues).map( item => {
                                return(<option key={item} value={item}>{item}</option>)
                            })
                        }
                    </select>*/}
                </td>
            )
        if (tpc.type === "select") // "Simple" select provides special logic
            return (
                <td style={tdStyle}>
                    <SelectF tp={tp} tpc={tpc} opdisable={true} /> 
                </td>
            )
        if (tpc.type === "textarea")
            return (
                <td style={tdStyle}>
                    <TextareaF tp={tp} tpc={tpc} />
                </td>
            )
        return (
            <td style={tdStyle}>
                <InputF tp={tp} tpc={tpc} />
            </td>
        )
  
    }
  }
 